import * as React from 'react';
import { StockIndicator } from '@grandvisionhq/inventory';
import { useFeatureToggles } from '@grandvisionhq/state';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import '../../../../types/product.js';
import { isFramesVariant } from '../../../../types/typeguards.js';
import { useEcommFacetContext } from '../../context/EcommFacetContext.js';

const VariantTreeStockIndicator = ({ treeLevelVariants , facetKey  })=>{
    const { activeVariant , facetConfigList  } = useProductData();
    const { isPrescriptionGlassesEnabled  } = useFeatureToggles();
    const { clickedFacetKeys  } = useEcommFacetContext();
    const { stock , channelAvailability , isExcludedFromCheckout  } = activeVariant;
    const facetConfig = facetConfigList === null || facetConfigList === void 0 ? void 0 : facetConfigList.find((config)=>config.facetKey === facetKey
    );
    const isLastTreeLevel = treeLevelVariants.every((variant)=>variant.childFacets.length === 0 || variant.childFacets.every((childFacet)=>childFacet.facetTerm === null
        )
    );
    if (!facetConfig || !facetKey) return null;
    const { requiresUserSelection  } = facetConfig;
    const hasBeenSelected = Boolean((clickedFacetKeys === null || clickedFacetKeys === void 0 ? void 0 : clickedFacetKeys.includes(facetKey)) || !requiresUserSelection || treeLevelVariants.length <= 1);
    const isSellableProduct = !isFramesVariant(activeVariant) || isPrescriptionGlassesEnabled;
    const shouldRender = Boolean(stock.enableStockIndicator && !isExcludedFromCheckout && hasBeenSelected && isLastTreeLevel && isSellableProduct);
    if (!shouldRender) return null;
    return /*#__PURE__*/ React.createElement(StockIndicator, {
        stockCount: stock.stockCount,
        allowBackOrder: stock.isAllowBackOrder,
        channelAvailability: channelAvailability
    });
};

export { VariantTreeStockIndicator };
//# sourceMappingURL=VariantTreeStockIndicator.js.map
